document.addEventListener('DOMContentLoaded', () => {
  const configuracao = $('input[name="configuracao[exibir_indicadores_rentabilidade_simulacao_pre_custo]"]');
  if (configuracao.length < 1) return;

  const bsSwitch = configuracao.parent().find('.bootstrap-switch');
  if (bsSwitch.length < 1) return;

  bsSwitch.on('switchChange.bootstrapSwitch', function(event, state) {
    const { cnpj, email } = configuracao.eq(1).data() || {};
    sendEventExibeMarkupSimulacaoPreCusto(cnpj, email, state);
  });
});

function sendEventExibeMarkupSimulacaoPreCusto(cnpj, email, state) {
  const posthogEvent = state ? 'Exibir markup no PDF da simulação de pré-custo' : 'Ocultar markup no PDF da simulação de pré-custo';
  const detail = { posthogEvent, trackCnpj: cnpj, trackEmail: email };
  const event = new CustomEvent("posthog:capture", { detail });
  document.dispatchEvent(event);
}
